import {
  Configure,
  Index,
  InstantSearch,
  SearchBox,
} from 'react-instantsearch-dom';
import algoliasearch from 'algoliasearch/lite';
import { useBreakpoint } from 'gatsby-plugin-breakpoints';

import FontIcon from 'components/icons';

import './styles/blog-search.scss';
import CustomHits from './hit-list';
import CustomResults from './results';
import CustomStats from './stats';

const algoliaClient = algoliasearch(
  process.env.GATSBY_ALGOLIA_APP_ID as string,
  process.env.GATSBY_ALGOLIA_SEARCH_KEY as string
);

const searchClient = {
  ...algoliaClient,
  search(requests) {
    if (requests.every(({ params }) => !params.query)) {
      // prevent a call to Algolia if the search query is empty
      return Promise.resolve({
        results: requests.map(() => ({
          hits: [],
          nbHits: 0,
          nbPages: 0,
          page: 0,
          processingTimeMS: 0,
        })),
      });
    }

    return algoliaClient.search(requests);
  },
};

const HitsInIndex = ({ index }) => (
  <Index indexName={ index.name }>
    <CustomStats />
    <CustomHits />
  </Index>
);

const SearchResult = ({ indices, className }) => (
  <div className={ className }>
    {indices.map(index => (
      <HitsInIndex key={ index.name } index={ index } />
    ))}
  </div>
);
const removeKeyboard = () =>
  // @ts-ignore
  (window.navigator.virtualKeyboard.overlaysContent = false);

const BlogSearch = ({ indices }) => {
  const breakpoints = useBreakpoint();
  return (
    <div className="blog-search-container">
      <InstantSearch searchClient={ searchClient } indexName="Posts">
        <Configure hitsPerPage={ 50 } attributesToSnippet={ ['content'] } />
        <header className="search-controls">
          {!breakpoints.sm && <FontIcon icon="search" />}
          <SearchBox
            searchAsYouType={ false }
            autoFocus={ true }
            translations={ { placeholder: 'Search When I Work Blog' } }
            reset="Clear"
            onReset={ removeKeyboard }
            submit={ breakpoints.sm ? <FontIcon icon="search" /> : 'Search' }
          />
        </header>
        <hr />
        <CustomResults>
          <SearchResult className="search-results" indices={ indices } />
        </CustomResults>
      </InstantSearch>
    </div>
  );
};

export default BlogSearch;
